import { render, staticRenderFns } from "./GraphCRM.vue?vue&type=template&id=f044fd06&"
import script from "./GraphCRM.vue?vue&type=script&lang=js&"
export * from "./GraphCRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports